var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-fares-list"},[_c('v-container',{staticClass:"related-fares-list-container"},[_c('v-btn',{staticClass:"btn-back",attrs:{"to":{name: 'pointOfSaleList'}}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._v(" Voltar\n        ")],1),_vm._v(" "),_c('list-related-fares')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }